import { render, staticRenderFns } from "./RegionAndDepartmentPicker.vue?vue&type=template&id=dae267dc&scoped=true"
import script from "./RegionAndDepartmentPicker.vue?vue&type=script&lang=js"
export * from "./RegionAndDepartmentPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae267dc",
  null
  
)

export default component.exports